import React, {useEffect, useState} from 'react';
import {FormGroup, FormSelect} from 'react-bootstrap';
import styles from './sidebar.module.scss';
import Accordions from "@/components/global/posts/sidebar/accordions";
import PostsService from "@/services/posts-service";
import {useNavigate, useParams} from "react-router-dom";

type Props = {
  key?: number,
  onSortChange: (sort: string) => void,
  sort: string | undefined
};

const PostsSidebar: React.FC<Props> = ({ onSortChange, sort }) => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const sortChange = (val: string) => {
    navigate(window.location.pathname + '?sort=' + val);
    onSortChange(val);
  }

  const [categories, setCategories] = useState<ICategory[]>([]);

  useEffect(() => {
    PostsService.getCategories().then(categories => {
      setCategories(categories);
    });
  }, []);

  return (
    <div className={styles.postsSidebar + (sidebarOpen ? ' ' + styles.open : '')}>
      <div className={styles.filterSection}>
        <div className={styles.header} onClick={() => setSidebarOpen(!sidebarOpen)}>
          <div className={styles.iconContainer}>
            <i className="fa fa-filter" />
          </div>{' '}
          <h4>
            فیلترها
          </h4>
        </div>
        <div className={styles.body}>
          <div className={styles.filter}>
            <FormGroup>
              <h5><label htmlFor="order">چیدمان آگهی ها</label></h5>
              <FormSelect id="order" defaultValue={sort} onChange={(e) => sortChange(e.target.value)}>
                <option value="newest">جدیدترین</option>
                <option value="oldest">قدیمی‌ترین</option>
                <option value="high-cost">گران‌ترین</option>
                <option value="low-cost">ارزان‌ترین</option>
                <option value="free">رایگان</option>
              </FormSelect>
            </FormGroup>
          </div>
          <div className={styles.filter}>
            <FormGroup>
              <h5><label>دسته بندی ها</label></h5>
              <Accordions categories={categories} />
            </FormGroup>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PostsSidebar;
